// extracted by mini-css-extract-plugin
module.exports = {"bottomPageTurn":"style_bottomPageTurn__oyjHz","button":"style_button__AaVpf"};